import { ProductType } from 'types/product.types';

import { LIKED_PRODUCTS_ADD } from '../action-types/products-page.action-types';

export type ProductsPageReducer = {
  likedProducts: ProductType[];
};

const initialState: ProductsPageReducer = {
  likedProducts: [],
};

const productsPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIKED_PRODUCTS_ADD: {
      return {
        ...state,
        likedProducts: action.data,
      };
    }
    default: {
      return state;
    }
  }
};

export default productsPageReducer;
